import { endpoints } from "@/utils/common/requests/endpoints";
import { useAction } from "@/utils/useQuery/useAction";

export function useCreateCrew() {
	return useAction({ url: endpoints.crew.CREATE(), method: "post" });
}
